import React from "react";

import { useSelector } from "react-redux";

import { PaymentMethod } from "constants/payments";

import { getPaymentMethodsByBuyerId } from "selectors";

import { Chip, ChipBag } from "./BaseChip";

interface PaymentMethodStyle {
  backgroundColor: string;
  color?: string;
}

const PaymentMethodStyleMap: Record<PaymentMethod, PaymentMethodStyle> = {
  [PaymentMethod.ACCOUNT]: { backgroundColor: "warning", color: "white" },
  [PaymentMethod.CASH]: { backgroundColor: "lightGreen" },
  [PaymentMethod.EFT]: { backgroundColor: "primaryHighlight", color: "white" },
  [PaymentMethod.CARD]: { backgroundColor: "success", color: "white" },
  [PaymentMethod.CHEQUE]: { backgroundColor: "lavender", color: "white" },
};

const DEFAULT_PAYMENT_METHOD_STYLE: PaymentMethodStyle = {
  backgroundColor: "gray95",
};

export const PaymentMethodChips = ({ buyerId }: { buyerId: string }) => {
  const paymentMethods = useSelector(getPaymentMethodsByBuyerId(buyerId));

  if (!paymentMethods.length) {
    return null;
  }

  return (
    <ChipBag>
      {paymentMethods.map(method => {
        const { backgroundColor, color } =
          PaymentMethodStyleMap[method] ?? DEFAULT_PAYMENT_METHOD_STYLE;
        return (
          <Chip key={method} backgroundColor={backgroundColor} color={color}>
            {method}
          </Chip>
        );
      })}
    </ChipBag>
  );
};
